export interface INkrDonorReferralConversionRate {
    centerId: number,
    centerAlias: string,
    donatedCount: number,
    referralCount: number,
    conversionRate: number,
    category: string
}